import React, { useEffect, useState } from "react";
import RadioButton from "./RaidoButton";
import { IoSend } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import {
  createMediaInformationAction,
  updateMediaInformationAction,
} from "../../Actions/MediaInformationAction/MedicaInformationAction";
import MediaAllInfoSend from "./MediaAllInfoSend";

const SendMediaInfo = ({
  branchId,
  visitId,
  followUp,
  mediaInformation,
  mediaAllInfo,
}) => {
  const createMediaInformation = useSelector(
    (state) => state.createMediaInformation
  );

  const { error, loading, data } = createMediaInformation;
  const createMediaAllInformation = useSelector(
    (state) => state.createMediaAllInformation
  );

  const { allInfo, loading: loadingAllInfo } = createMediaAllInformation;

  const [selectedValue, setSelectedValue] = useState("");
  const [doctorList, setDoctorList] = useState([]);
  const [surgeryList, setSurgeryList] = useState([]);
  const dispatch = useDispatch();
  const [state, setState] = useState({
    id: "",
    hospitalName: "",
    dateOfSurgery: "",
  });
  useEffect(() => {
    if (data?.id) {
      setState((prev) => ({
        ...prev,
        id: data?.id,
        hospitalName: data?.hospital_name,
        dateOfSurgery: data?.date_of_surgery,
      }));
      return;
    } else {
      setState((prev) => ({
        ...prev,
        id: mediaInformation?.id,
        hospitalName: mediaInformation?.hospital_name,
        dateOfSurgery: mediaInformation?.date_of_surgery,
      }));
      return;
    }
  }, [data, visitId, mediaInformation]);
  useEffect(() => {
    // console.log(data);

    followUp?.map((follow) => {
      setDoctorList([]);
      setSurgeryList([]);
      follow.organ?.map((organ) => {
        setSurgeryList((prev) => [...prev, organ]);
      });
      follow.doctor?.map((doctor) => {
        setDoctorList((prev) => [...prev, doctor]);
      });
    });
  }, [followUp, visitId]);
  const handleChange = (e) => {
    setSelectedValue(e.target.value);
  };
  const handleStateChange = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log(state.id);
    if (state?.id) {
      if (selectedValue == 1) {
        dispatch(
          updateMediaInformationAction(
            state.id,
            state.hospitalName,
            "coustm",
            state.dateOfSurgery,
            visitId,
            branchId
          )
        );
        return;
      }

      if (selectedValue == 2) {
        dispatch(
          updateMediaInformationAction(
            state.id,
            state.hospitalName,
            "all",
            state.dateOfSurgery,
            visitId,
            branchId
          )
        );
        return;
      }

      return;
    }
    if (selectedValue == 1) {
      dispatch(
        createMediaInformationAction(
          state.hospitalName,
          "coustm",
          state.dateOfSurgery,
          visitId,
          branchId
        )
      );
      return;
    }
    if (selectedValue == 2) {
      dispatch(
        updateMediaInformationAction(
          state.id,
          state.hospitalName,
          "all",
          state.dateOfSurgery,
          visitId,
          branchId
        )
      );
      return;
    }
  };
  return (
    <div className="py-4">
      <form action="" onSubmit={handleSubmit}>
        <div className="p-4 ">
          <h2 className="mb-4 text-xl font-semibold">Choose an option:</h2>
          <div className="flex gap-2 justify-center ">
            <RadioButton
              label="Coustm Information"
              value="1"
              checked={selectedValue === "1"}
              onChange={handleChange}
            />
            <RadioButton
              label="All Information"
              value="2"
              checked={selectedValue === "2"}
              onChange={handleChange}
            />
          </div>
        </div>
        {selectedValue == 1 && (
          <div className="px-4 grid grid-cols-2 gap-2">
            <div className="flex flex-col">
              <label htmlFor="doctor">Doctor *</label>
              <input
                type="text"
                value={doctorList || ""}
                id="doctor"
                className="input w-full"
              />
            </div>
            <div className="flex flex-col ">
              <label htmlFor="type">Type Of Surgery *</label>
              <input
                type="text"
                value={surgeryList || ""}
                readOnly
                id="type"
                className="input w-full"
              />
            </div>

            <div className="flex flex-col ">
              <label htmlFor="hos">Hospital Name *</label>
              <input
                type="text"
                id="hos"
                value={state.hospitalName || ""}
                name="hospitalName"
                onChange={handleStateChange}
                className="input w-full"
              />
              {<p className="text-red-500">{error && error.hospital_name}</p>}
            </div>
            <div className="flex flex-col ">
              <label htmlFor="date">Date</label>
              <input
                type="date"
                id="date"
                name="dateOfSurgery"
                value={state.dateOfSurgery || ""}
                onChange={handleStateChange}
                className="input w-full"
              />
              {<p className="text-red-500">{error && error.date_of_surgery}</p>}
            </div>
          </div>
        )}
        <div className="px-4 pt-2 mt-2">
          {selectedValue == 1 && (
            <button
              disabled={loading}
              className={`btn-blue ${
                loading && "opacity-50"
              } gap-16 group mt-2`}
            >
              Send
              <p className="  -translate-x-2 group-hover:-translate-x-0  duration-500">
                <IoSend />
              </p>
            </button>
          )}

          {selectedValue == 2 && (
            <MediaAllInfoSend
              loadingAllInfo={loadingAllInfo}
              allInfo={allInfo}
              mediaAllInfo={mediaAllInfo}
              visitId={visitId}
              branchId={branchId}
            />
          )}
        </div>
      </form>
    </div>
  );
};

export default SendMediaInfo;
